import { Component, Input } from '@angular/core';

@Component({
  selector: 'fcp-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionComponent {
  @Input() data: any;
  public step = 0;

  setStyleTable(str) {
    if (str) {
      return str
        .replace(/<table/gi, '<div class="responsive-table"><table')
        .replace(/<\/table>/gi, '</table></div>');
    }
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }
}
